export const setSessionCookie = (name, value) => {
  const cookieValue = encodeURIComponent(JSON.stringify(value));
  document.cookie = `${name}=${cookieValue}; path=/; Secure; SameSite=Lax`;
};


export const getSessionCookie = (name) => {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  if (match) {
    try {
      return JSON.parse(decodeURIComponent(match[2]));
    } catch (error) {
      console.error("Error parsing session cookie:", error);
      return null;
    }
  }
  return null;
};


export function clearAllCookies() {
  document.cookie.split(";").forEach((cookie) => {
    const name = cookie.split("=")[0].trim();
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;`;
  });
}

export const handleImageError = (event) => {
    if (event.target.src.includes("cover")) {
      event.target.src = "cover/default.jpg";
    } else {
      event.target.src = "profile_pics_icons/default.jpg";
    }
  };

